import React, { createContext, useState, Fragment, useContext, useEffect } from 'react';
import { CustomModal } from '../../components/modal/modalBase';
import { CloseButton } from '../../components';

export const SecondaryModalContext = createContext();

export const SecondaryModalProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState('');
    const [params, setParams] = useState({});
    const [styles, setStyles] = useState({});

    return (
        <Fragment>
            <SecondaryModalContext.Provider
                value={{
                    activeModal,
                    setActiveModal,
                    params,
                    setParams,
                    setStyles,
                    styles,
                }}
            >
                {children}
            </SecondaryModalContext.Provider>
        </Fragment>
    );
};

export const useSecondaryModal = () => {
    const { setActiveModal, params, setParams, styles, setStyles } = useContext(SecondaryModalContext);

    return {
        openSecondary: (params = {}, styles) => {
            setActiveModal(true);
            setParams(params);
            setStyles(styles);
        },
        closeSecondary: () => {
            setActiveModal('');
            setParams({});
            setStyles({});
        },
        params,
        styles,
    };
};

export const SecondaryModals = () => {
    const { activeModal } = useContext(SecondaryModalContext);
    const { closeSecondary, params, styles } = useSecondaryModal();

    useEffect(() => {
        if (activeModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [activeModal]);

    return (
        <CustomModal
            handleOpenClose={closeSecondary}
            openDefault={activeModal ? activeModal : false}
            content={
                <div style={{ outline: 'none', ...styles?.styles?.wrapperStyle }} className="modal-wrapper-style open-sans">
                    <div className="modal-header-style">
                        <CloseButton handleCLic={closeSecondary} />
                    </div>
                    <div style={styles?.styles?.bodyStyle ? { ...styles?.styles?.bodyStyle } : {}} className="modal-body-style-small">
                        {params}
                    </div>
                </div>
            }
        />
    );
};
